// extracted by mini-css-extract-plugin
export default {"swipeBar":"_jepFLO"};